/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable camelcase */
import React, { useEffect, useState, useMemo, useRef } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { compose } from 'redux';
import { RadioSearch } from 'crm/_components';
import axios from 'axios';

import { injectIntl, FormattedMessage as FM } from 'react-intl';

import { DateCell, StatusCell, CalendarWithLabel } from 'common/components';

import { getCrmAccountTrades } from 'crm/users/_redux';
import queryString from 'query-string';

import { useParams, withRouter } from 'react-router-dom';
import { NewCRMTable } from 'crm/_newComponents';

import { staticStyles } from './style';

const startDate = moment().add(-6, 'day').startOf('day').unix();

const endDate = moment().add(1, 'day').startOf('day').unix();

const startCalendar = moment().add(-6, 'day').startOf('day');

const endCalendar = moment().add(1, 'day').startOf('day');

const ClientAccountOrderHistoryOrdersTable = ({ accountTrades, getCrmAccountTrades, location }) => {
  const { summary } = accountTrades;
  const { id, idAccount } = useParams();
  const [radio, setRadio] = useState('closed');
  const [dates, setDates] = useState({ start: startDate, end: endDate });
  const [openTradesData, setOpenTradesData] = useState(null);
  const query = useMemo(() => ({ ...queryString.parse(location.search) }), [location.search]);
  const errorCountRef = useRef(0);
  const isInitialMount = useRef(true);
  const queryPage = query.page;
  const datesStr = useMemo(() => JSON.stringify(dates), [dates]);

  const onCalendarChange = (start, end) => {
    setDates(prev => ({ ...prev, start, end }));
  };

  useEffect(() => {
    getCrmAccountTrades({
      id,
      accountId: idAccount,
      operation: radio,
      search:
        radio === 'open'
          ? {}
          : {
              start: moment(dates.start).format('x'),
              end: moment(dates.end).format('x'),
            },
    });
  }, [radio, queryPage, datesStr]);

  // Open orders 5秒定时刷新
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    errorCountRef.current = 0;

    if (radio === 'open') {
      const fetchOpenTrades = async () => {
        if (errorCountRef.current >= 5) {
          return;
        }

        try {
          const response = await axios.get(`/crm/contacts/${id}/account/${idAccount}/trade/list/open/`);
          if (response.status === 400 || !response.data || !response.data.trades) {
            errorCountRef.current += 1;
            return;
          }

          errorCountRef.current = 0;
          setOpenTradesData(response.data);
        } catch (error) {
          errorCountRef.current += 1;
        }
      };

      fetchOpenTrades();

      const intervalId = setInterval(() => {
        if (errorCountRef.current < 5) {
          fetchOpenTrades();
        } else {
          clearInterval(intervalId);
        }
      }, 5000);

      return () => clearInterval(intervalId);
    }
  }, [radio, id, idAccount]);

  const memoizedOnChangeParams = useMemo(() => ({}), []);

  const columns = [
    {
      Header: 'justOrder',
      Cell: ({ rowData: { id } }) => <span>{id}</span>,

      isPreviewCell: true,
    },
    {
      Header: 'justSymbol',
      Cell: ({ rowData: { symbol } }) => (symbol ? <span>{symbol}</span> : '一'),
      isPreviewCell: true,
    },
    {
      Header: 'justType',
      Cell: ({ rowData: { command } }) => <StatusCell statusCode={command} noDot noTranslate />,
    },
    {
      Header: 'justOpenTime',
      Cell: ({ rowData: { open_time } }) => <DateCell value={open_time} />,
    },
    {
      Header: () => <FM id={radio === 'delayed' ? 'justExpiration' : 'justCloseTime'}>{txt => txt}</FM>,
      Cell: ({ rowData: { close_time, expiration } }) => (
        <div>{close_time || expiration ? <DateCell value={close_time || expiration} /> : '一'}</div>
      ),
    },
    {
      Header: 'justOpenPrice',
      Cell: ({ rowData: { price, open_price } }) => (open_price ? <span>{price || open_price}</span> : '一'),
    },
    {
      Header: 'justClosePrice',
      Cell: ({ rowData: { close_price } }) => (close_price ? <span>{close_price}</span> : '一'),
      Footer: () => <FM id="justTotal">{txt => <span className="Footer__Total">{txt}</span>}</FM>,
    },
    {
      Header: 'justLots',
      Cell: ({ rowData: { lots, command } }) => <span>{lots === 0.01 && command === 'In/Out' ? 0 : lots}</span>,
      Footer: () => <div className="TotalCell">{summary ? summary.lots : ''}</div>,
    },
    {
      Header: 'S/L',
      Cell: ({ rowData: { stoploss } }) => <span>{stoploss !== null && stoploss !== undefined ? stoploss : '一'}</span>,
    },
    {
      Header: 'T/P',
      Cell: ({ rowData: { takeprofit } }) => (
        <span>{takeprofit !== null && takeprofit !== undefined ? takeprofit : '一'}</span>
      ),
    },
    {
      Header: 'justCommission',
      Cell: ({ rowData: { commission } }) => <span>{commission}</span>,
      Footer: () => (
        <div className="TotalCell">
          {radio === 'open' && openTradesData?.summary
            ? openTradesData.summary.commission === 0
              ? '一'
              : openTradesData.summary.commission
            : summary
            ? summary.commission === 0
              ? '一'
              : summary.commission
            : '一'}
        </div>
      ),
    },
    {
      Header: 'justSwap',
      Cell: ({ rowData: { swap } }) => <span>{swap}</span>,
      Footer: () => <div className="TotalCell">{summary ? summary.swap : '一'}</div>,
    },
    {
      Header: 'justProfit',
      Cell: ({ rowData: { profit } }) => (
        <span style={{ color: profit > 0 ? '#1890ff' : profit < 0 ? '#ff4d4f' : 'inherit' }}>{profit}</span>
      ),
      Footer: () => (
        <div className="TotalCell">
          {radio === 'open' && openTradesData?.summary
            ? openTradesData.summary.profit
            : summary
            ? summary.profit
            : '一'}
        </div>
      ),
      isPreviewCell: true,
    },
  ];

  return (
    <div className="ClientPageHistory__bottom">
      <div className="ClientPageHistory__radio-list">
        <RadioSearch
          externalClass="ClientPageHistory__radio-closed-orders"
          onClick={() => setRadio('closed')}
          textId="justDealOrders"
          active={radio === 'closed'}
        />
        <RadioSearch
          externalClass="ClientPageHistory__radio-open-orders"
          onClick={() => setRadio('open')}
          textId="justOpenOrders"
          active={radio === 'open'}
        />
        {/* <RadioSearch
          externalClass="ClientPageHistory__radio-pending-orders"
          onClick={() => setRadio('delayed')}
          textId="crmPendingOrders"
          active={radio === 'delayed'}
        /> */}
        {radio !== 'open' && (
          <CalendarWithLabel
            label={<FM id="justCloseTime">{txt => txt}</FM>}
            onChangeFunc={onCalendarChange}
            onChangeParams={memoizedOnChangeParams}
            defaultStartDate={startCalendar}
            defaultEndDate={endCalendar}
          />
        )}
      </div>

      <NewCRMTable
        columns={columns}
        data={radio === 'open' && openTradesData ? openTradesData.trades : accountTrades.trades}
        hasFooter
      />
      <style jsx global>
        {staticStyles}
      </style>
    </div>
  );
};

export default compose(
  withRouter,
  injectIntl,
  connect(
    state => ({
      accountTrades: state.crm.users.accountTrades,
      accountTradesAreLoaded: state.crm.users.accountTradesAreLoaded,
    }),
    { getCrmAccountTrades: data => getCrmAccountTrades.request(data) }
  )
)(ClientAccountOrderHistoryOrdersTable);
